import years from './years/years';
import contractTypes from './types/contractTypes';
import tracking from './tracking/tracking';
import fees from './fees/contractFees';
import teams from './teams/teams';
import scripts from './scripts/scripts';
import appointments from './appointments/appointments';

import rest from './rest';

const handlers = [
    ...years, 
    ...contractTypes, 
    ...fees, 
    ...teams, 
    ...scripts, 
    ...tracking,
    ...appointments
];

export { handlers, rest };
